import AlertSuccess from 'components/helpers/SvgIcon/icons/alert-success';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

export type CheckoutStepsItems = {
  name?: string;
  value?: number;
};

type CheckoutStepsProps = {
  allSteps: CheckoutStepsItems[];
  active: number;
};

const CheckoutSteps = ({ allSteps, active }: CheckoutStepsProps): JSX.Element => {
  return (
    <>
      <div className={classnames('flex', 'flex-wrap', 'justify-center', 'pl-[7%]')}>
        {allSteps?.map((item) => {
          if (item.value !== undefined && item?.value <= active) {
            return (
              <div key={item.value} className={classnames('w-1/3', 'relative')}>
                <div className={classnames('flex', 'items-center')}>
                  <div className={classnames('step-circle', 'complete')}>
                    <AlertSuccess />
                  </div>
                  {item.value !== 3 && <progress className={classnames('h-[3px]', 'w-full')} />}
                </div>
                <div
                  className={classnames('absolute', 'mt-2', 'text-sm', 'text-solidBlack', {
                    'left-[-20%]': item.value !== 3,
                    '-left-2.5': item.value === 3,
                  })}
                >
                  {item.name}
                </div>
              </div>
            );
          }
          return (
            <React.Fragment key={item.value}>
              <div className={classnames('hidden', 'w-1/3', 'relative', 'md:block')}>
                <div className={classnames('flex', 'items-center')}>
                  <div
                    className={classnames('step-circle', {
                      inactive: item.value !== undefined && item.value > active + 1,
                      active: item.value !== undefined && item.value <= active + 1,
                    })}
                  />
                  {item.value !== 3 && <progress className={classnames('h-[3px]', 'w-full')} />}
                </div>
                <div
                  className={classnames(
                    'absolute',
                    'mt-2',
                    'text-sm',
                    {
                      'text-gray-darkGray': item.value !== undefined && item.value > active + 1,
                      'text-solidBlack': item.value !== undefined && item.value <= active + 1,
                    },
                    {
                      'left-[-20%]': item.value !== 3,
                      '-left-2.5': item.value === 3,
                    }
                  )}
                >
                  {item.name}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};
export default CheckoutSteps;
